export default __webpack_public_path__ + "static/media/arrow-horizontal.032e3906.svg";